/**
 * Боты «по вызову» (наш Chatwoot). Договор — _vendor/chatwoot/_giper/BOT_INVOCATION.md,
 * маршруты — config/initializers/11_unia_bot_invocations.rb, контроллер
 * custom/app/controllers/api/v1/accounts/unia_bot_invocations_controller.rb.
 */
import { cwFetch } from './chatwoot';

const base = (acc: number) => `/api/v1/accounts/${acc}`;

export interface CallableBot {
  id: number;
  name: string;
  description?: string | null;
  thumbnail?: string | null;
}

/** GET conversations/:id/unia_bots → { bots } — боты по вызову, подключённые к каналу этой переписки. */
export async function listBots(accountId: number, displayId: number): Promise<CallableBot[]> {
  const r = await cwFetch<{ bots: CallableBot[] }>(`${base(accountId)}/conversations/${displayId}/unia_bots`);
  return r.bots ?? [];
}

/**
 * POST conversations/:id/unia_bot_invocations { agent_bot_id, message_ids, instruction } → { status, id }.
 * message_ids — обязательно хотя бы одно сообщение этой переписки (не больше 50): бот получает их с файлами
 * и расшифровками. Бот отвечает заметками; внешнее действие делает только после «Подтвердить».
 */
export function invokeBot(accountId: number, displayId: number, p: { agentBotId: number; messageIds: number[]; instruction: string }) {
  return cwFetch<{ status: string; id: number }>(`${base(accountId)}/conversations/${displayId}/unia_bot_invocations`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      agent_bot_id: p.agentBotId,
      message_ids: p.messageIds,
      ...(p.instruction.trim() ? { instruction: p.instruction.trim() } : {}),
    }),
  });
}

export type BotDecision = 'confirm' | 'cancel';

/** POST unia_bot_invocations/:id/decision { decision: 'confirm' | 'cancel' } → { status, state }. */
export function decideBot(accountId: number, invocationId: number, decision: BotDecision) {
  return cwFetch<{ status: string; state: string }>(`${base(accountId)}/unia_bot_invocations/${invocationId}/decision`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ decision }),
  });
}
